export enum Permission {
    ADMIN = 'cpe:admin',
}
